import './NotificationBadge.scss';

export default function NotificationBadge() {
  return <div className="notification-badge" />;
}
